import { useEffect, useState } from 'react';

/**
 * Touch-aware mobile detection. Unlike a pure viewport width check, this
 * also treats any device with a touch interface as "mobile" so tablets in
 * landscape orientation (>768px wide) still get the mobile code paths
 * (e.g. auto-focus suppression).
 *
 * Returns a live boolean that updates on resize.
 */
const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' &&
      (window.innerWidth <= breakpoint || 'ontouchstart' in window)
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(
        window.innerWidth <= breakpoint || 'ontouchstart' in window
      );
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
